import { render, staticRenderFns } from "./blue-title.vue?vue&type=template&id=16466d76&scoped=true&"
import script from "./blue-title.vue?vue&type=script&lang=js&"
export * from "./blue-title.vue?vue&type=script&lang=js&"
import style0 from "./blue-title.vue?vue&type=style&index=0&id=16466d76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16466d76",
  null
  
)

export default component.exports